import React from "react"
import { Grid, Typography } from "@material-ui/core"
import clsx from "clsx"

import { AIFollowUpAttempt, AIFollowUpIntention } from "@/protocols/chatBot"

import ContrastChip from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/ContrastChip"

import { colors } from "@/styles/colors"

import useStyles from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/AIFollowUpBlock/AIFollowUpAttemptSectionContainer/styles"

type AIFollowUpFrequencyOption = {
	waitTimeInMinutes: number
	label: string
}

const AIFollowUpFrequencyOptions: AIFollowUpFrequencyOption[] = [
	{ waitTimeInMinutes: 1, label: "1 minuto" },
	{ waitTimeInMinutes: 30, label: "30 minutos" },
	{ waitTimeInMinutes: 60, label: "1 hora" },
	{ waitTimeInMinutes: 120, label: "2 horas" },
	{ waitTimeInMinutes: 360, label: "6 horas" },
	{ waitTimeInMinutes: 720, label: "12 horas" },
	{ waitTimeInMinutes: 1440, label: "24 horas" }
]

const AIFollowUpIntentionLabels: Record<AIFollowUpIntention, string> = {
	"first-contact": "Retomar contato",
	reinforcement: "Reforço",
	closing: "Encerramento"
}

const getFrequencyLabel = (waitTimeInMinutes: number): string => {
	const option = AIFollowUpFrequencyOptions.find(opt => opt.waitTimeInMinutes === waitTimeInMinutes)
	return option?.label || `${waitTimeInMinutes} minutos`
}

const getIntentionLabel = (intention: AIFollowUpIntention): string => AIFollowUpIntentionLabels[intention]

type AIFollowUpAttemptSectionContainerProps = {
	attempt: AIFollowUpAttempt
	attemptIndex: number
	isWabaChannel: boolean
}

const ATTEMPT_ORDINAL_LABELS = ["Primeira", "Segunda", "Terceira", "Quarta", "Quinta", "Sexta", "Sétima", "Oitava", "Nona", "Décima"]

const getAttemptTitle = (attemptIndex: number): string => {
	const ordinalLabel = ATTEMPT_ORDINAL_LABELS[attemptIndex] || `${attemptIndex + 1}ª`

	return `${ordinalLabel} tentativa de contato`
}

const AIFollowUpAttemptSectionContainer: React.FC<AIFollowUpAttemptSectionContainerProps> = (props) => {
	const {
		attempt,
		attemptIndex,
		isWabaChannel
	} = props

	const classes = useStyles()

	return (
		<Grid
			container
			direction="column"
			className={classes.summaryContainer}
		>
			<Grid
				item
				className={classes.summaryHeader}
			>
				<Typography className={classes.summaryTitle}>
					{getAttemptTitle(attemptIndex)}
				</Typography>
			</Grid>

			<Grid
				item
				className={classes.summaryLines}
			>
				<ContrastChip
					title={getFrequencyLabel(attempt.waitTimeInMinutes)}
					backgroundColor={colors.blue[400]}
				/>
				<ContrastChip
					title={getIntentionLabel(attempt.intention)}
					backgroundColor={colors.blue[400]}
				/>
			</Grid>

			{isWabaChannel && (
				<Grid
					item
					className={classes.templateWrapper}
				>
					<Grid className={classes.templateDivider} />
					<Typography className={clsx(classes.summaryTitle, classes.templateLabel)}>
						Se a janela de comunicação estiver fechada, enviar o template:
					</Typography>
					<Grid className={classes.templateSection}>
						<ContrastChip
							title={attempt.wabaTemplate?.name || "Nenhum template selecionado"}
							backgroundColor={colors.blue[400]}
						/>
					</Grid>
				</Grid>
			)}
		</Grid>
	)
}

export default AIFollowUpAttemptSectionContainer
